<div class="tw-h-screen tw-flex tw-flex-col tw-animate-pulse tw-items-center tw-justify-center tw-gap-8">
  @if(icon){
  <img [src]="icon" [alt]="brand?.name || 'VOXR.AI'" class="tw-w-32 tw-h-32 tw-object-contain">
  } @else {
  <div alt="Voxr" class="tw-w-32 tw-h-32 tw-object-contain"></div>
  }
  <div class="tw-text-3xl">Loading...</div>
</div>
